export default __webpack_public_path__ + "f59ab48479bd2e7786e81332bc296624.svg";